import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [info, setInfo] = useState(null);
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const maxAttempts = 8;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setInfo(r.data);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          await refreshUser();
          return;
        }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        attempts += 1;
        if (attempts >= maxAttempts) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch (err) {
        setStatus("error");
      }
    };
    poll();
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-mm-parchment bg-topo">
      <Navbar />
      <div className="container mx-auto py-20 max-w-xl text-center">
        {status === "polling" && (
          <>
            <Loader2 size={48} className="mx-auto text-mm-steel animate-spin" />
            <h1 className="font-heading text-3xl font-black text-mm-navy mt-4">Recording your summit ascent...</h1>
            <p className="text-mm-navy/70 mt-2">Verifying payment with Stripe — hold steady.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={56} className="mx-auto text-mm-gold" strokeWidth={2.5} />
            <h1 className="font-heading text-4xl font-black text-mm-navy mt-4">You're on the Summit Pass!</h1>
            <p className="text-mm-navy/70 mt-2">Unlimited expeditions, Rescue Route, and Explorer's Challenge now unlocked.</p>
            <Link to="/dashboard" className="btn-trail btn-gold mt-6 inline-flex" data-testid="success-dashboard-btn">Back to expedition HQ</Link>
          </>
        )}
        {(status === "expired" || status === "timeout" || status === "error") && (
          <>
            <AlertCircle size={48} className="mx-auto text-mm-navy" />
            <h1 className="font-heading text-3xl font-black text-mm-navy mt-4">Payment not confirmed yet</h1>
            <p className="text-mm-navy/70 mt-2">Don't worry — if you completed checkout, your plan will update shortly. Refresh in a minute.</p>
            <Link to="/pricing" className="btn-trail btn-outline-navy mt-6 inline-flex">Back to pricing</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
